import type { TypeRequestReason } from '../types';

// ----------------------------------------------------------------------------

function getStatus(xhrInstance: XMLHttpRequest, reason: TypeRequestReason): string {
    switch (reason) {
        case 'abort':
            return 'Request aborted.';

        case 'timeout':
            return 'Request timeout.';

        case 'error':
            return 'Network error. Please check your connection.';

        case 'success':
            return 'Request completed successfully.';

        case 'failed':
            if (xhrInstance.status === 404) {
                return 'Requested page not found.';
            }

            if (xhrInstance.status === 500) {
                return 'Internal Server Error.';
            }

            if (xhrInstance.status >= 400 && xhrInstance.status < 500) {
                return 'Client error.';
            }

            if (xhrInstance.status >= 500) {
                return 'Server error.';
            }

            return 'Request failed.';

        default:
            return 'Unknown request status.';
    }
}

// ----------------------------------------------------------------------------

export default getStatus;
